<template>
<div class="section-container">
    <CollapsedContent :title="content.title" :index="5">
        <div class="container-box">
            <div class="list">
                <div v-for="text in content.content" :key="text">{{text}}</div>
            </div>
            <div id="re-box-right" class="box right">
                <div v-for="text in content.right" :key="text">{{ text }}</div>
            </div>
        </div>
    </CollapsedContent>
</div>
</template>

<script setup>
import { updateOnScroll,elementHeight,elementBottom, elementTop } from "basic-scroll-animations";
import CollapsedContent from "@/components/CollapsedContent.vue";
import textMap from "@/scripts/locale.js";
import { useSectionStore } from "@/store/sectionStore";
import { ref, onMounted } from "vue";

const store = useSectionStore();

const content = ref(textMap.realEstate);

onMounted(()=>{
    if(!store.isSafari){
        let lstart = elementBottom("#boxes");
        let height = 2*elementHeight("#boxes");
        if(window.innerWidth<window.innerHeight){
            lstart = lstart/2;
            height = height/2;
        }
        if(window.innerHeight < 500){
            lstart = 0;
            height = 0.01;
        }
        updateOnScroll("#re-box-right")
            .from(lstart,{opacity:0, translateX: 100})
            .to(lstart+height,{opacity:1, translateX: 0});
    }
});
</script>

<style scoped>
</style>